import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { SetWidthCTAButton } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderCareersDesktop";
import { HeaderContainer, HeaderLink, HeaderLinkButton, SMALL_LOGO_WIDTH } from "@faire/retailer-visitor-shared/components/Header/styled";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { getWindow, getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { ArrowRight } from "@faire/web--source/slate/icons/Arrow";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Hamburger } from "@faire/web--source/ui/Hamburger";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import jobOpeningsPath from "@faire/web-api--source/routes/careers/openings";
import { observer } from "mobx-react";
import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
var HeaderCareersMobileBase = function(props) {
    var location = useZustandLocation(function(state) {
        return state.pathname;
    });
    var isOnJobOpeningsPage = location.pathname === jobOpeningsPath();
    var pathList = props.pathList;
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var _React_useState = _sliced_to_array(React.useState(getWindowOrThrow().scrollY), 2), windowY = _React_useState[0], setWindowY = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), shouldShowMenu = _React_useState1[0], setShouldShowMenu = _React_useState1[1];
    /**
     * This the handle navigation callback deals with detecting scroll down
     * when the menu is opened behaviour is that when menu is opened,
     * when scroll down is detected, the menu will close
     */ var handleNavigation = useCallback(function() {
        if (!shouldShowMenu) {
            return;
        }
        if (windowY < getWindowOrThrow().scrollY) {
            setShouldShowMenu(false);
        }
        setWindowY(getWindowOrThrow().scrollY);
    }, [
        shouldShowMenu,
        windowY
    ]);
    useEffect(function() {
        var _getWindow;
        setWindowY(getWindowOrThrow().scrollY);
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("scroll", handleNavigation);
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("scroll", handleNavigation);
        };
    }, [
        handleNavigation
    ]);
    useEffect(function() {
        setShouldShowMenu(false);
    }, [
        location
    ]);
    return /*#__PURE__*/ _jsxs(StyledHeaderContainer, {
        $menuOpened: shouldShowMenu,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(HeaderLinkButton, {
                        onClick: function() {
                            return setShouldShowMenu(!shouldShowMenu);
                        },
                        children: /*#__PURE__*/ _jsx(Hamburger, {
                            open: shouldShowMenu,
                            color: shouldShowMenu ? Core.icon.inverse : Core.icon.default,
                            "data-test-id": "mobile-menu"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(StyledRow, {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(HeaderLink, {
                                to: home(),
                                children: viewportWidth <= SMALL_LOGO_WIDTH ? /*#__PURE__*/ _jsx(SmallFaireLogo, {
                                    inverse: shouldShowMenu
                                }) : /*#__PURE__*/ _jsx(FaireLogo, {
                                    inverse: shouldShowMenu
                                })
                            }),
                            isOnJobOpeningsPage ? null : /*#__PURE__*/ _jsx(SetWidthCTAButton, {
                                variant: shouldShowMenu ? "secondary" : "primary",
                                linkTo: jobOpeningsPath(),
                                "data-test-id": "job-openings-button",
                                children: /*#__PURE__*/ _jsxs(StyledSignUpButtonContent, {
                                    children: [
                                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "yF3MJe",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "All Job Openings"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(StyledArrowRight, {})
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(MenuContainer, {
                $menuOpened: shouldShowMenu,
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "8x"
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "4x"
                            }),
                            pathList.map(function(pathObject) {
                                return /*#__PURE__*/ _jsxs(Column, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                to: pathObject.path,
                                                children: pathObject.label
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            width: "2x"
                                        })
                                    ]
                                }, pathObject.label);
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export var HeaderCareersMobile = observer(HeaderCareersMobileBase);
var MenuContainer = styled(Row).withConfig({
    componentId: "sc-f2848485-0"
})([
    "width:100%;position:absolute;bottom:0px;background-color:",
    ";transform:translateY(100%);max-height:",
    ";overflow:hidden;transition:max-height 0.5s linear;"
], Core.surface.inverse, function(props) {
    return props.$menuOpened ? "500px" : "0px";
});
var SmallFaireLogo = styled(FaireLogo).withConfig({
    componentId: "sc-f2848485-1"
})([
    "width:",
    ";"
], getSpacing("8x"));
var StyledRow = styled(Row).withConfig({
    componentId: "sc-f2848485-2"
})([
    "width:100%;"
]);
var StyledHeaderContainer = styled(HeaderContainer).withConfig({
    componentId: "sc-f2848485-3"
})([
    "background-color:",
    ";"
], function(props) {
    return props.$menuOpened ? Core.surface.default : Core.surface.inverse;
});
var StyledArrowRight = styled(ArrowRight).withConfig({
    componentId: "sc-f2848485-4"
})([
    "opacity:0;transition:0.5s ease;position:absolute;top:0;bottom:0;margin:auto 0;right:2px;"
]);
var SignUpButtonContent = styled.span.withConfig({
    componentId: "sc-f2848485-5"
})([
    "transition:0.5s ease;position:relative;padding:0 10px;"
]);
var StyledSignUpButtonContent = styled(SignUpButtonContent).withConfig({
    componentId: "sc-f2848485-6"
})([
    "padding:0px;"
]);
